<template>
  <div>
    <h3 @click="enableDebug($event)" class="display-4">Manage Quotes</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :list-options="list_options"
      :new-to="{ name: 'ocom_quote.create', params: { id: 0 } }"
      :query-select-options="options"
      :schema="schema"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      @filter_changed="update_filter($event)"
      @options_changed="update_table($event)"
      @reset_table="reset_table"
      new-button-text="New Quote"
    >
      <template slot="middle">
        <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        />
      </template>
    </o-list-toolbar>

    <b-table
      :fields="fields"
      :items="items"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order == 'desc'"
      @row-selected="onRowSelected"
      @sort-changed="change_sort"
      bordered
      class="o-list"
      head-variant="light"
      no-local-sorting
      selectable
      striped
      thead-class="o-gradient-header"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template
        slot="top-row"
        slot-scope="{ columns, fields }"
        v-if="filterRow"
      >
        <td :key="field.key" class="p-0" v-for="field in fields">
          <span v-if="field.key === 'client'">
            <o-form-select
              :loading="optionOcomClientWorking"
              :options="optionOcomClientItems"
              @change="filter_changed"
              blank-option-text=""
              name="client"
              sort-field="name"
              text-field="name"
              v-model="list_options.qbe.client"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'created_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.created_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'estimated_weeks'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.estimated_weeks"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'lost_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              hide-time
              v-model="list_options.qbe.lost_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'modified_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              v-model="list_options.qbe.modified_date"
            ></o-flatpickr-wrapper>
          </span>
          <span v-if="field.key === 'notes'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.notes"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'old_quote'">
            <o-form-select
              :loading="optionOcomQuoteOldWorking"
              :options="optionOcomQuoteOldItems"
              @change="filter_changed"
              blank-option-text=""
              name="old_quote"
              sort-field="project_name"
              text-field="project_name"
              v-model="list_options.qbe.old_quote"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'project_name'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.project_name"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'quote_name'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.quote_name"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'quote_type'">
            <o-form-select
              :loading="optionCodeQuoteTypeWorking"
              :options="optionCodeQuoteTypeItems"
              @change="filter_changed"
              blank-option-text=""
              name="quote_type"
              sort-field="description"
              text-field="description"
              v-model="list_options.qbe.quote_type"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'status'">
            <o-form-select
              :loading="optionCodeQuoteStatusWorking"
              :options="optionCodeQuoteStatusItems"
              @change="filter_changed"
              blank-option-text=""
              name="status"
              sort-field="description"
              text-field="description"
              v-model="list_options.qbe.status"
              value-field="id"
            >
              <template v-slot:first>
                <option :value="null"></option>
              </template>
            </o-form-select>
          </span>
          <span v-if="field.key === 'versions'">
            <b-form-input
              @change="filter_changed"
              class="rounded-0 px-0"
              type="search"
              v-model="list_options.qbe.versions"
            ></b-form-input>
          </span>
          <span v-if="field.key === 'won_date'">
            <o-flatpickr-wrapper
              @change="filter_changed"
              class="rounded-0 px-0"
              hide-time
              v-model="list_options.qbe.won_date"
            ></o-flatpickr-wrapper>
          </span>
        </td>
      </template>
      <template slot="cell(client)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'client'"
        >
          <lookup-display
            :list="optionOcomClientItemsById"
            :value="item.client"
            default-value="-"
            display-field="name"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(estimated_weeks)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'estimated_weeks'"
        >
          <number-display :decimals="0" :value="item.estimated_weeks" />
        </o-link-cell>
      </template>
      <template slot="cell(lost_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'lost_date'"
        >
          <date-display
            :value="item.lost_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'notes'"
        >
          <default-display :value="item.notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(old_quote)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'old_quote'"
        >
          <lookup-display
            :list="optionOcomQuoteOldItemsById"
            :value="item.old_quote"
            default-value="-"
            display-field="project_name"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(project_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'project_name'"
        >
          <default-display :value="item.project_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(quote_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'quote_name'"
        >
          <default-display :value="item.quote_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(quote_type)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'quote_type'"
        >
          <lookup-display
            :list="optionCodeQuoteTypeItemsById"
            :value="item.quote_type"
            default-value="-"
            display-field="description"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(status)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'status'"
        >
          <lookup-display
            :list="optionCodeQuoteStatusItemsById"
            :value="item.status"
            default-value="-"
            display-field="description"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(versions)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'versions'"
        >
          <default-display :value="item.versions"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(won_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'ocom_quote.edit', params: { id: item.id } }"
          :when="first_column_key === 'won_date'"
        >
          <date-display
            :value="item.won_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'ocom_quote.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :offset="list_options.offset"
      :page-options="rows_per_page_items"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("OcomQuote", "ocom_quote"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("OcomQuote"),
    CreateCodeTableFetchMixin([
      "OcomClient",
      "CodeQuoteType",
      "OcomQuoteOld",
      "CodeQuoteStatus",
    ]),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.OcomQuote,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.OcomQuote),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        {
          name: "In Progress",
          code: "inprogress",
          options: { offset: 0, sort: "modified_date" },
        },
        { name: "Won!", code: "won", options: { offset: 0, sort: "won_date" } },
        {
          name: "Lost",
          code: "lost",
          options: { offset: 0, sort: "lost_date" },
        },

        {
          name: "Active",
          code: "active",
          options: { offset: 0, sort: "modified_date" },
        },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "modified_date" },
        },
        {
          name: "All",
          code: "all",
          options: { offset: 0, sort: "modified_date" },
        },
      ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
      },
    };
  },
  computed: {
    options() {
      return {
        OcomClient: {
          options: this.optionOcomClientItems,
          textField: "name",
          valueField: "id",
        },
        CodeQuoteType: {
          options: this.optionCodeQuoteTypeItems,
          textField: "description",
          valueField: "id",
        },
        OcomQuoteOld: {
          options: this.optionOcomQuoteOldItems,
          textField: "project_name",
          valueField: "id",
        },
        CodeQuoteStatus: {
          options: this.optionCodeQuoteStatusItems,
          textField: "description",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "client",
        "quote_name",
        "project_name",
        "quote_type",
        "status",
        "estimated_weeks",
        "won_date",
        "lost_date",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>
